var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDocumentSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 29,
    rx: 5,
    fill: "#8A8C89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 11.0625V21.75C20.75 22.9926 19.7426 24 18.5 24H9.5C8.25736 24 7.25 22.9926 7.25 21.75V8.25C7.25 7.00736 8.25736 6 9.5 6H15.6875L20.75 11.0625ZM17.375 11.0625C16.443 11.0625 15.6875 10.307 15.6875 9.375V7.125H9.5C8.87868 7.125 8.375 7.62868 8.375 8.25V21.75C8.375 22.3713 8.87868 22.875 9.5 22.875H18.5C19.1213 22.875 19.625 22.3713 19.625 21.75V11.0625H17.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15C18 15 16.5 12.25 14 12.25C11.5 12.25 10 15 10 15C10 15 11.5 17.75 14 17.75C16.5 17.75 18 15 18 15ZM10.5863 15C10.6148 14.9566 10.6473 14.9084 10.6836 14.8562C10.8511 14.616 11.0982 14.2965 11.4161 13.9786C12.0605 13.3341 12.9403 12.75 14 12.75C15.0597 12.75 15.9395 13.3341 16.5839 13.9786C16.9018 14.2965 17.1489 14.616 17.3164 14.8562C17.3527 14.9084 17.3852 14.9566 17.4137 15C17.3852 15.0434 17.3527 15.0916 17.3164 15.1438C17.1489 15.384 16.9018 15.7035 16.5839 16.0214C15.9395 16.6659 15.0597 17.25 14 17.25C12.9403 17.25 12.0605 16.6659 11.4161 16.0214C11.0982 15.7035 10.8511 15.384 10.6836 15.1438C10.6473 15.0916 10.6148 15.0434 10.5863 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.75C13.3096 13.75 12.75 14.3096 12.75 15C12.75 15.6904 13.3096 16.25 14 16.25C14.6904 16.25 15.25 15.6904 15.25 15C15.25 14.3096 14.6904 13.75 14 13.75ZM12.25 15C12.25 14.0335 13.0335 13.25 14 13.25C14.9665 13.25 15.75 14.0335 15.75 15C15.75 15.9665 14.9665 16.75 14 16.75C13.0335 16.75 12.25 15.9665 12.25 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDocumentSvg);
export default __webpack_public_path__ + "static/media/view-document-svg.ddc0702f63d1e90dd8a7fe64408714c2.svg";
export { ForwardRef as ReactComponent };